export function useNavigationSeparator(numberOfSeparators = 1): null[] {
  return Array.from({ length: numberOfSeparators }, () => null)
}
